import {Button} from "@headlessui/react";
import React, {useMemo, useState} from "react";
import {updatePmsSearchDetails} from "../../redux/actions/pmsSearch";
import {useDispatch, useSelector} from "react-redux";
import withUtilities from "../../hooks/withUtilities";
import {useUtilityData} from "../../utilities/contexts";
import {PmsItemTitle} from "./ItemTitle";

const days = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

const PreferencesForm = ({onNext}) => {
  const dispatch = useDispatch();
  const utilities = useUtilityData((utilityData) => utilityData);
  const pmsSearch = useSelector((state) => state.pmsSearch);

  const [error, setError] = useState(false);
  const [availability, setAvailability] = useState(pmsSearch.availability ?? [
    [false, false, false, false, false, false, false],
    [false, false, false, false, false, false, false],
    [false, false, false, false, false, false, false],
    [false, false, false, false, false, false, false],
    [false, false, false, false, false, false, false],
  ]);
  const [therapistGender, setTherapistGender] = useState(pmsSearch.therapistGender?.length > 0 ? utilities.genders?.map(gender =>
    gender.value === pmsSearch.therapistGender[0].value ?
      pmsSearch.therapistGender[0]
      : gender) ?? [] : utilities.genders)

  const tryNext = () => {
    let usesAvailability = false;
    for(const time of availability) {
      if(usesAvailability) {
        break;
      }

      for(const day of time) {
        if(day) {
          usesAvailability = true;
          break;
        }
      }
    }

    if(!availability || !usesAvailability) {
      setError(true);
      return;
    }

    completeStep();

    if (onNext) {
      onNext();
    }
  }

  const completeStep = () => {
    dispatch(updatePmsSearchDetails({
      availability,
      therapistGender: therapistGender.filter(gender => gender.selected),
    }));
  }

  const updateAvailability = (time, day, selected) => {
    setError(false);
    const tmpAvail = [...availability];
    const availabilities = [...tmpAvail];
    const row = availabilities[time]
    row[day] = selected;
    availabilities[time] = row;
    tmpAvail.availability = availabilities;
    setAvailability(tmpAvail);
  }

  const updateGender = (value, selected) => {
    let tmpGender = utilities.genders;
    if(value !== null && selected) {
      tmpGender = tmpGender.map(gender => gender.value === value ? {
        ...gender,
        selected: true,
      } : gender);
    }
    setTherapistGender(tmpGender);
  }

  const genderSelected = useMemo(() => {
    if(!therapistGender) {
      return false;
    }
    return therapistGender.filter(gender => gender.selected).length > 0;
  }, [therapistGender])

  return (
    <div className='flex flex-col w-full gap-4 mt-6 px-2'>
      <div className='flex flex-col w-full gap-1'>
        <PmsItemTitle required>
          When would you like to see your therapist?
        </PmsItemTitle>
        <div className='grid grid-cols-[110px_1fr]'>
          <div/>
          <div className='grid grid-cols-7 gap-1'>
            {days.map((day, i) => <p key={`weekDay_${i}`} className='text-sm font-bold text-center h-[30px]'>{day}</p>)}
          </div>
        </div>
        <div className='grid grid-cols-[110px_1fr]'>
          <div className='flex flex-col gap-2.5'>
            {utilities.availability.map((label, i) => label && label !== '' ? (
                <p className='font-bold text-sm py-1' key={`timeName_${i}`}>{label}</p>
              ) : null
            )}
          </div>
          <div className={`grid grid-cols-7 gap-1 ${error && 'ring-2 ring-offset-4 ring-red-500 rounded'}`}>
            {availability.map((availSet, id) => availSet.map((avail, day) => (
              <Button key={`day_${id}_${day}`}
                      onClick={() => updateAvailability(id, day, !avail)}
                      className={`text-white text-sm ${avail ? 'bg-brand' : 'bg-brand-off'} opacity-1 hover:opacity-[0.7] rounded-[5px] flex justify-center items-center py-1 px-3 cursor-pointer`}>
                <p className='absolute'>{avail ? '\u2714' : ''}</p>
              </Button>
            )))}
          </div>
        </div>
        {error && (
          <span className='text-red-500 text-xs pt-1'>Please select your preferred times for a session</span>
        )}
      </div>
      <div className='flex flex-col w-full gap-1'>
        <PmsItemTitle>
          What gender would you prefer to see?
        </PmsItemTitle>
        <div className='flex flex-wrap gap-1.5'>
          <Button
            onClick={() => updateGender(null, null)}
            className={`px-4 py-2 ${!genderSelected ? 'bg-brand-alt' : 'bg-brand-off'} flex flex-1 justify-center gap-2 items-center rounded-full opacity-1 cursor-pointer hover:opacity-[0.7] transition`}>
            <p
              className={`${!genderSelected ? 'text-white' : 'text-brand-text'} text-sm font-bold transition w-max flex-nowrap text-nowrap`}>No preference</p>
          </Button>
          {therapistGender.map(gender => (
            <Button
              onClick={() => updateGender(gender.value, !gender.selected)}
              className={`px-4 py-2 ${gender.selected ? 'bg-brand-alt' : 'bg-brand-off'} flex flex-1 justify-center gap-2 items-center rounded-full opacity-1 cursor-pointer hover:opacity-[0.7] transition`}
              key={`gender_${gender.value}`}>
              <p
                className={`${gender.selected ? 'text-white' : 'text-brand-text'} text-sm font-bold transition`}>{gender.label}</p>
            </Button>
          ))}
        </div>
      </div>
      <div className='py-4 w-full flex justify-end'>
        <Button onClick={tryNext}
                className='bg-brand text-white font-bold px-4 py-2 rounded-full hover:bg-white hover:text-brand transition'>
          Next step
        </Button>
      </div>
    </div>
  )
}

export default withUtilities(PreferencesForm);

